import React from "react";
import "./BBS.css";
import { Card } from "../../../components/Card";
import useSWR from "swr";
import API_ENDPOINTS from "../../../apis/endpoints";
import {
    Box,
    Checkbox,
    CircularProgress,
    FormControl,
    InputLabel,
    ListItemText,
    MenuItem,
    OutlinedInput,
    Select,
    Tab,
    Tabs,
} from "@mui/material";
import { styled } from "@mui/styles";
import { useTheme } from "@mui/material/styles";
import AppPrograms from "./appPrograms/AppPrograms";
import Affiliate from "./affiliate/Affiliate";
import Marketing from "./marketing/Marketing";
import LastRefreshed from "../LastRefreshed";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 10.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

export const StyledTabs = styled(Tabs)(({ theme }) => ({
    //used this in Creator Tech Tab
    borderBottom: `1px solid ${theme.palette.neutral[200]}`,
    "& .MuiTabs-indicator": {
        backgroundColor: theme.palette.secondary[500],
    },
}));

export const StyledTab = styled(Tab)(({ theme }) => ({
    //used this in Creator Tech Tab
    textTransform: "none",
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(15),
    marginRight: theme.spacing(1),
    "&.Mui-selected": {
        color: theme.palette.secondary[500],
    },
}));

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const tabs = [
    { id: 0, title: "App Programs" },
    { id: 1, title: "Affiliate" },
    { id: 2, title: "Marketing" },
];

export default function BBS() {
    const {
        data: weekDataSet,

        isLoading,
    } = useSWR(`${API_ENDPOINTS.BBS_WEEK}`);

    const { data: weekData, refreshed_at } = weekDataSet ?? {};

    if (isLoading) {
        return <CircularProgress />;
    }

    return <WeekDisplay weeks={weekData} refreshed_at={refreshed_at} />;
}

function WeekDisplay({ weeks, refreshed_at }) {
    const theme = useTheme();

    const [selectedWeeks, setSelectedWeeks] = React.useState(
        weeks.slice(-6).map((week) => week.key)
    );

    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleWeekChange = (event) => {
        setSelectedWeeks(event.target.value);
    };

    return (
        <Card>
            <div className="header-section">
                <Box
                    sx={{
                        borderBottom: 1,
                        borderColor: theme.palette.neutral[200],
                    }}
                >
                    <StyledTabs
                        value={value}
                        onChange={handleChange}
                        aria-label="BBS tabs"
                    >
                        {tabs.map((tab, index) => (
                            <StyledTab
                                key={tab.id}
                                label={tab.title}
                                {...a11yProps(index)}
                            />
                        ))}
                    </StyledTabs>
                </Box>
                {/* Week Selector */}
                <FormControl sx={{ m: 1, width: 300 }}>
                    <InputLabel id="week-multi-select-label">Weeks</InputLabel>
                    <Select
                        labelId="week-multi-select-label"
                        id="week-multi-select"
                        multiple
                        value={selectedWeeks}
                        onChange={handleWeekChange}
                        input={<OutlinedInput label="All Weeks" />}
                        renderValue={(selected) =>
                            weeks.length === selectedWeeks.length
                                ? "All weeks"
                                : weeks
                                      ?.filter((week) =>
                                          selected.includes(week.key)
                                      )
                                      .map((week) => week.name)
                                      .join(", ")
                        }
                        MenuProps={MenuProps}
                    >
                        {weeks?.map((week) => (
                            <MenuItem key={week.key} value={week.key}>
                                <Checkbox
                                    checked={
                                        selectedWeeks.indexOf(week.key) > -1
                                    }
                                />
                                <ListItemText primary={week.name} />
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>

            {/* Pass selected weeks and active tab index */}
            <SelectedWeeks weeks={selectedWeeks} tab={value} />

            <LastRefreshed date={refreshed_at} />
        </Card>
    );
}

// SelectedWeeks component to display content based on active tab
function SelectedWeeks({ weeks, tab }) {
    const TabList = [AppPrograms, Affiliate, Marketing]; // Map tabs to components

    const ActiveTab = TabList[tab]; // Get active tab component

    const {
        data: BBSData,
        error: academyError,
        isLoading: academyIsLoading,
    } = useSWR(`${API_ENDPOINTS.BBS_DATA}?weeks=${weeks.join(",")}`);

    if (academyIsLoading) {
        return <CircularProgress />;
    }

    // Render active tab component with data
    return (
        <div className="cards-container">{<ActiveTab data={BBSData} />}</div>
    );
}
